module.exports = __webpack_public_path__ + "static/media/leki.e58501c0.svg";